import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/UpdatePaymentMethodLink.graphql';
import { Query, QueryupdatePaymentMethodLinkArgs } from '../../__generated__/globalTypes';

export const useUpdatePaymentMethodLinkQuery = (
  options?: QueryHookOptions<Query, QueryupdatePaymentMethodLinkArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryupdatePaymentMethodLinkArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useUpdatePaymentMethodLinkLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryupdatePaymentMethodLinkArgs>
): QueryResult<Query, QueryupdatePaymentMethodLinkArgs> & {
  getUpdatePaymentMethodLink: LazyQueryExecFunction<Query, QueryupdatePaymentMethodLinkArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getUpdatePaymentMethodLink, result] = useLazyQuery<Query, QueryupdatePaymentMethodLinkArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getUpdatePaymentMethodLink, ...result };
};

export const useUpdatePaymentMethodLinkPromiseQuery = () => {
  const client = useApolloClient();

  const getUpdatePaymentMethodLink = useCallback(
    (options?: Omit<QueryOptions<QueryupdatePaymentMethodLinkArgs, Query>, 'query'>) =>
      client.query<Query, QueryupdatePaymentMethodLinkArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getUpdatePaymentMethodLink };
};
// Suspense Query Hooks
export const useUpdatePaymentMethodLinkSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryupdatePaymentMethodLinkArgs>
) => {
  const result = useSuspenseQuery<Query, QueryupdatePaymentMethodLinkArgs>(QUERY, {
    ...options
  });

  return result;
};
